import { QueryClientProvider as TanstackQueryClientProvider } from "@tanstack/react-query";
import type React from "react";

import { queryClient } from "@/libs/queryClient";

/**
 * Wrapper around Tanstack's QueryClientProvider
 * Provides React Query functionality to the entire app
 *
 * Usage:
 * <QueryClientProvider>
 *   <App />
 * </QueryClientProvider>
 */
export function QueryClientProvider({ children }: { children: React.ReactNode }) {
  return <TanstackQueryClientProvider client={queryClient}>{children}</TanstackQueryClientProvider>;
}
